import * as React from "react";

import { Text } from "src/library/components/Text";

import { OrderType } from "../api/orders.api";

interface IProps {
  type?: OrderType;
}

/**
 * Formats the order type
 */
export const OrderTypeText: React.ReactFCWithChildren<IProps> = ({ type }) => {
  const orderTypeText = React.useMemo(() => {
    switch (type) {
      case "adhoc":
        return "Ad Hoc";

      case "scheduled":
        return "Standing order";

      case "bulk":
        return "Bulk Order Import";

      default:
        return "-";
    }
  }, [ type ]);

  return (
    <Text
      weight="bold"
      className="type-code"
    >
      {orderTypeText}
    </Text>
  );
};
